import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';

import Button from '../../../../components/Button';
import Logo from '../../../../components/Logo';
import Modal from '../../../../components/Modal';
import { navigateTo } from '../../../../contrib/Utils/navigateTo';

interface IProps {
  eventId: string;
}

interface IState {
  helpOpen: boolean;
}

class EventLogin extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      helpOpen: false
    };

    this.toggleHelp = this.toggleHelp.bind(this);
  }

  public toggleHelp(): void {
    this.setState({ helpOpen: !this.state.helpOpen });
  }

  public render(): JSX.Element {
    const { eventId } = this.props;
    const modal = {
      text: `A GHIN Number is an official number provided by the USGA and is used in official
      USGA, local association or club events. If you do not have a GHIN number, that's ok, you
      can still register and use WAGL. If you get one at a later date you can add it in your
      player settings tab.`,
      title: 'Ghin Number Information'
    };
    return (
      <div className="event-login wrapper">
        <Paper elevation={1} className="paper">
          <h4>ARE YOU ALREADY A MEMBER?</h4>
          <Logo powered={true} poweredText="This event is powered by " />

          <span className="button-small" onClick={this.toggleHelp}>
            WHAT IS WAGL?
          </span>
          <Modal
            id="club15-help-modal"
            open={this.state.helpOpen}
            onClose={this.toggleHelp}
            {...modal}
          />

          <Button
            className="button button-shadow"
            variant="contained"
            color="primary"
            onClick={navigateTo(`/login?next=/event/${eventId}`)}
          >
            YES, LOGIN NOW
          </Button>
          <Button
            className="button"
            variant="outlined"
            color="primary"
            onClick={navigateTo(`/register?next=/event/${eventId}`)}
          >
            NOT YET
          </Button>
        </Paper>
      </div>
    );
  }
}

export { EventLogin };
